"use strict";var _react=require("react");Object.defineProperty(exports,"__esModule",{value:!0}),exports.useSessionStorage=exports.useLocalStorage=void 0;/**
 * A prefix to identify session and local storage keys saved using
 * the storage hooks in this application.
 */const STORAGE_KEYS_PREFIX="",useStorage=(a,b)=>(c,d)=>{if(!c)throw new Error(`"storageKey" must be a nonempty string, but "${c}" was passed.`);const e=a.getItem(b+c);let f=null;null!==e&&(f=JSON.parse(e));const[g,h]=(0,_react.useState)(f??d);return(0,_react.useEffect)(()=>{a.setItem(b+c,JSON.stringify(g))},[g,c]),[g,h]},useLocalStorage=exports.useLocalStorage=useStorage(localStorage,""),useSessionStorage=exports.useSessionStorage=useStorage(sessionStorage,"");/**
 * Saves data in local storage.
 * @param storageKey A string to identify the value being being cached.
 * @param fallbackState The default value when no value has been stored yet.
 * @returns A stateful value, and a function to update it.
 * @example 
 * const [collapsed, setCollapsed] = useLocalStorage('isSidebarCollapsed', false);
 *//**
 * Saves data in session storage.
 * @param storageKey A string to identify the value being being cached.
 * @param fallbackState The default value when no value has been stored yet.
 * @returns A stateful value, and a function to update it.
 * @example 
 * const [collapsed, setCollapsed] = useSessionStorage('isSidebarCollapsed', false);
 */